import React, { FunctionComponent, useCallback } from 'react';
import CallsGraphContainer from './calls-graph-container';
import { endOfYear, startOfYear, subYears } from 'date-fns';
import { convertTableData } from '../utils/convert-table-data';
import { apiClient } from 'axios-client';
import { CountByMonth } from '../utils/count-by-month.type';

type CallsGraphRepositoryProps = {
  bilikZoneIds?: number[];
  proViewIds?: number[];
  year?: number;
  compareYear?: number;
  filters?: any[];
};

const now = new Date();

const CallsGraphRepository: FunctionComponent<CallsGraphRepositoryProps> = ({
  bilikZoneIds,
  proViewIds,
  year = now.getFullYear(),
  compareYear = subYears(now, 1).getFullYear(),
  filters,
}) => {
  const getYearData = useCallback(
    async (year: number, proViewIds?: number[], bilikZoneIds?: number[]) => {
      const date = new Date(now);
      date.setFullYear(year);

      const result = await apiClient.post('event/bilik-calls-by-month', {
        after: startOfYear(date),
        before: endOfYear(date),
        bilikZoneIds,
        proViewIds,
        filters,
      });

      const countByMonth: CountByMonth[] = result.data;

      return countByMonth;
    },
    [filters, now],
  );

  const fetchData = useCallback(async () => {
    const data: CountByMonth[] = [];

    if (compareYear !== year) {
      const compareYearData = await getYearData(
        compareYear,
        proViewIds,
        bilikZoneIds,
      );

      data.push(...compareYearData);
    }

    const yearData = await getYearData(year, proViewIds, bilikZoneIds);

    data.push(...yearData);

    return convertTableData(data, [year, compareYear]);
  }, [bilikZoneIds, proViewIds, year, compareYear, getYearData]);

  return <CallsGraphContainer fetchData={fetchData} />;
};

export default CallsGraphRepository;
